import {useRef, useEffect, useMemo, useCallback} from 'react'
/** @jsxImportSource @emotion/react */
import {css} from '@emotion/react'
import styled from '@emotion/styled'

import {useTheme} from '@mui/material/styles'

import useMediaQuery from '@mui/material/useMediaQuery'

import {connect} from 'react-redux'

import {panTo, setClickedMarkerData} from '../../../actions'

import {formatTime, formatMoney} from '../../../utils'

import Tags from '../../generics/Tags'



const cssStyles = ({isExtraSmallScreen, theme}) => ({
  root: css`
    display: flex;
    flex-direction: column;
    width: 100%;
    overflow: hidden;
  `,
  // title: css` 
  //   font-weight: ${isExtraSmallScreen ? '600' : '600'};
  //   font-size: ${isExtraSmallScreen ? '1.1rem' : '1.4rem'};
  //   line-height: 1.2;
  //   margin-bottom: ${isExtraSmallScreen ? '2px' : '0em'};
  //   display: -webkit-box;
  //   -webkit-box-orient: vertical;
  //   -webkit-line-clamp: 3;
  //   overflow: hidden;
  // `,
  subtitle: css`
    font-size: ${isExtraSmallScreen ? '0.9rem' : '1rem'};
    font-weight: 500;
    color: rgb(255, 0, 149);
    margin-bottom: ${isExtraSmallScreen ? '3px' : '7px'};
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
  `,
  location: css`
    display: flex;
    align-items: center;
    gap: 5px;
    margin-bottom: ${isExtraSmallScreen ? '2px' : '5px'};
    width: 100%;

    & > p {
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 1;
      color: #000;
      font-size: ${isExtraSmallScreen ? '0.9rem' : '1rem'};
      font-weight: 500;
    }

    & > svg {
      color: #555555;
    }
  `,
  descriptionContainer: css`
    overflow: hidden;
    flex: 1 1 auto;
    max-width: 100%;
  `,
  description: css`
    font-size: 0.9rem;
    font-weight: 400;
    color: #555555;
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    text-overflow: ellipsis;
  `,
  tags: css`
    overflow: hidden;
    display: flex;
    align-items: flex-end;
    width: 100%;
    margin-top: 5px;
  `
})



  const Title = styled.h3(({ theme }) => `
    font-weight: 600;
    font-size: ${theme.breakpoints.only('xs') ? '1.1rem' : '1.4rem'};
    line-height: 1.2;
    margin-bottom: ${theme.breakpoints.only('xs') ? '2px' : '0'};
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    overflow: hidden;
  `)




const MapListItemInformation = ({
  panTo,
  performance,
  containerRef,
  setClickedMarkerData
}) => {

  const theme = useTheme()

  const isExtraSmallScreen = useMediaQuery(theme => theme.breakpoints.only('xs'))

  const styles = cssStyles({isExtraSmallScreen, theme})

  // Used to clip the description text if text overflows
  // const rootRef = useRef()
  // const descriptionRef = useRef()

  // const [height, setHeight] = useState(0)

  const {
    tags,
    name,
    start,
    end,
    price,
    location,
    coordinates,
    descriptionPlainText,
  } = performance.attributes || {}


  const time = formatTime(start) + ' - ' + formatTime(end)
  const money = price && price > 0 && formatMoney(price)
  const shortLocation = location.split(',').slice(0,2).join(', ')



  // Used to clip the description text if text overflows
  // useEffect(() => {
  //   if (descriptionRef.current && containerRef.current && rootRef.current) {

  //     // Nodes
  //     const rootNode = rootRef.current
  //     const containerNode = containerRef.current
      
  //     // Calculate available space using the three nodes
  //     const rootHeight = rootNode.clientHeight  
  //     const containerHeight = containerNode.clientHeight
      
  //     const availableSpace = containerHeight - rootHeight
      
  //     // Get the computed styles of the description element 
  //     const descriptionNode = descriptionRef.current
  //     const computedStyles = window.getComputedStyle(descriptionNode)
      
  //     // Calculate how many lines can fit in the remianing space
  //     const lineHeight = parseFloat(computedStyles.getPropertyValue('line-height'))
  //     const lines = parseInt(availableSpace / lineHeight)

      
  //     // Set the number of lines
  //     descriptionNode.style['-webkit-line-clamp'] = lines

  //     setHeight(lines * lineHeight)
  //   }
  // }, [rootRef, containerRef, descriptionRef])




  const panToLocation = useCallback((e) => {
    e.preventDefault()
    e.stopPropagation()
    panTo({lat: coordinates[1], lng: coordinates[0]}, true)
    setClickedMarkerData(performance)
  }, [coordinates, performance, panTo, setClickedMarkerData])




  return (
    <div css={styles.root}>
      <Title>{name}</Title>

      <p css={styles.subtitle}>
       {time}

       {Boolean(money) && 
          <>
            &nbsp; • &nbsp;
            {money}
          </>
        }
      </p>

      <div css={styles.location}>
        <p onClick={panToLocation}>
          {shortLocation}
        </p>
      </div>


      {descriptionPlainText && 
        <div css={styles.descriptionContainer}>
          <p css={styles.description}>
            {descriptionPlainText}
          </p>
        </div>
      }


      <div css={styles.tags}>
        <Tags tags={tags} variant='text' size='small' type='overlay' margin='top' />
      </div>
    </div>
  )
}


export default connect(null, {panTo, setClickedMarkerData})(MapListItemInformation)




